import { TABLE_COLUMN_WIDTH } from "components/ModelCompare/constants";

import type { Section } from "../types";
import { wifiProducts } from "./product-sets/wifiProductSet";
import {
  antennaType,
  connectedDevices,
  dedicatedSpectral,
  dimensions,
  extendedRangeMode6Ghz,
  powerMethodPoe,
  radio6Ghz,
  redundantRj45Port,
  rfFilteringTechnology,
  uplink,
  weatherproofing,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "./properties";

export const WifiOverview: Section = {
  properties: [
    dimensions,
    wifiTechnology,
    radio6Ghz,
    extendedRangeMode6Ghz,
    dedicatedSpectral,
    rfFilteringTechnology,
    antennaType,
    wifiCoverage,
    connectedDevices,
    weatherproofing,
    powerMethodPoe,
    uplink,
    redundantRj45Port,
    wifiMounting,
  ],
  products: wifiProducts,
  columnWidth: TABLE_COLUMN_WIDTH,
  isOverviewPage: true,
  showBadges: true,
};
